import Button from "components/atoms/Button";
import InputDate from "components/atoms/InputDate";
import InputField from "components/atoms/InputField";
import InputSelect from "components/atoms/InputSelect";
import { useFormik } from "formik";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Fasyankes from "services/Fasyankes";
import Wilayah from "services/Wilayah";
import { errorToastNotif } from "utils/common";
import {
  LastEducationOptions,
  NumberOfMicroscopicTrainingOptions,
  PageMode,
  ProficiencyTestingInstitutionOptions,
  Source,
  TrainingProvidingInstitutionsOptions,
  UserLevel,
  YesAndNoOptions,
  YesAndNoTestPanelOptions,
  YesAndNoTrainingValueOptions,
  TypeofCompetencyTestOptions,
  CompetencyTestResultsFasyankesOptions,
  EmployeeStatusOptions,
} from "utils/constant";
import React from "react";
import MikroscopisFakses from "services/MicroskopisFaskes";
import { checkScoreInvalid } from "utils/helpers";

const WilayahService = new Wilayah();
const FasyankesService = new Fasyankes();
const MikroscopisService = new MikroscopisFakses();

const FormComponent = ({ selectedItem, pageMode, handlePageModeChange }) => {
  const [urbanvillages, setUrbanvillages] = useState([]);

  const { currentUser } = useSelector((state) => state.authReducer);
  const [levelIdValue, setLevelIdValue] = useState("");
  const [levelDataOptions, setLevelDataOptions] = useState({
    provinces: [],
    districts: [],
    fasyankes: [],
  });

  const [selectedProvince, setSelectedProvince] = useState(
    currentUser?.province_id
  );
  const [selectedDistrict, setSelectedDistrict] = useState(
    currentUser?.district_id
  );
  const [selectedFasyankes, setSelectedFasyankes] = useState(
    currentUser?.fasyankes_id
  );

  const disableField = [
    "namapetugas",
    "stspegawai",
    "nip",
    "tlahir",
    "tglmulaikerja",
    "pddkan",
    "jumplthan",
    "institusipmberiplth",
    "institusipmberiplthsebutkan",
    "thnplthanakhir",
    "nilaiplth",
    "hslplthsensi",
    "hslplthspesi",
    "hslplthakurasi",
    "hslplthhtungprst",
    "tglbimtekakhir",
    "bimtekpanel",
    "hslbimteksensi",
    "hslbimtekspesi",
    "hslbimtekakurasi",
    "hslbimtekhtungprst",
    "tglujiprofis",
    "institusiujiprofis",
    "institusiujiprofissebutkan",
    "hslujiprofis",
    "hslprofissensi",
    "hslprofisspesi",
    "hslprofisakurasi",
    "hslprofisparasit",
    "tglujikompakhir",
    "jenisujikompakhir",
    "hslujikompakhir",
  ];

  const trainingRangeFields = [
    "institusipmberiplth",
    "institusipmberiplthsebutkan",
    "thnplthanakhir",
    "nilaiplth",
    "hslplthsensi",
    "hslplthspesi",
    "hslplthakurasi",
    "hslplthhtungprst",
  ];

  const isTrainingDisabled = (values) =>
    values.sediamikroskopis !== "Ya" ||
    values.jumplthan === 0 ||
    values.jumplthan === "0";

  const isGeneralDisabled = (values) =>
    values.sediamikroskopis !== "Ya";

  const fetchAllProvincies = async () => {
    try {
      const response = await WilayahService.getAll(Source.PROVINCE, {
        page: 1,
        limit: 9999,
      });
      setLevelDataOptions((prevState) => ({
        ...prevState,
        provinces: response.province.map((item) => {
          return {
            label: item.name,
            value: `${item.id}|${item.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDistrictByProvince = async (provinceId) => {
    try {
      const response = await WilayahService.getAll(Source.DISTRICT, {
        page: 1,
        limit: 9999,
        searchBy: "province_id",
        searchValue: provinceId,
      });

      setLevelDataOptions((prevState) => ({
        ...prevState,
        districts: response.district.map((item) => {
          return {
            label: item.name,
            value: `${item.id}|${item.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchFasyankesByDistrict = async (districtId) => {
    try {
      const response = await FasyankesService.getAll(Source.FASYANKES, {
        page: 1,
        limit: 9999,
        searchBy: "district_id",
        searchValue: districtId,
        excludePkm: false,
      });

      setLevelDataOptions((prevState) => ({
        ...prevState,
        fasyankes: response.fasyankes.map((item) => {
          return {
            label: item.name,
            value: `${item.id}|${item.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllProvincies();

    if (selectedProvince) {
      fetchDistrictByProvince(selectedProvince?.split("|")[0]);
    }
    if (selectedDistrict) {
      fetchFasyankesByDistrict(selectedDistrict?.split("|")[0]);
    }
  }, [selectedProvince, selectedDistrict]);

  const formik = useFormik({
    initialValues: {
      province_id: "",
      district_id: "",
      fasyankes_id: "",
      sediamikroskopis: "",
      namapetugas: "",
      stspegawai: "",
      nip: "",
      tlahir: "",
      tglmulaikerja: "",
      pddkan: "",
      jumplthan: "",
      institusipmberiplth: "",
      institusipmberiplthsebutkan: "",
      thnplthanakhir: "",
      nilaiplth: "",
      hslplthsensi: "",
      hslplthspesi: "",
      hslplthakurasi: "",
      hslplthhtungprst: "",
      tglbimtekakhir: "",
      bimtekpanel: "",
      hslbimteksensi: "",
      hslbimtekspesi: "",
      hslbimtekakurasi: "",
      hslbimtekhtungprst: "",
      tglujiprofis: "",
      institusiujiprofis: "",
      institusiujiprofissebutkan: "",
      hslujiprofis: "",
      hslprofissensi: "",
      hslprofisspesi: "",
      hslprofisakurasi: "",
      hslprofisparasit: "",
      tglujikompakhir: "",
      jenisujikompakhir: "",
      hslujikompakhir: "",
    },
    validate: (values) => {
      const errors = {};

      if (!values.sediamikroskopis) {
        errors.sediamikroskopis = "Ketersediaan mikroskopik wajib diisi";
      }

      if (values.sediamikroskopis === "Ya") {
        if (!values.namapetugas) {
          errors.namapetugas = "Nama mikroskopis wajib diisi";
        }

        if (!values.stspegawai) {
          errors.stspegawai = "Status kepegawaian wajib diisi";
        }

        if (!values.nip) {
          errors.nip = "NIP/KTP wajib diisi";
        } else if (values.nip.length < 16) {
          errors.nip = "Nomor NIP/KTP 16 digit";
        }

        if (!values.tlahir) {
          errors.tlahir = "Tanggal lahir wajib diisi";
        }

        if (!values.pddkan) {
          errors.pddkan = "Pendidikan terakhir wajib diisi";
        }

        if (!values.tglmulaikerja) {
          errors.tglmulaikerja =
            "Tanggal mulai bekerja sebagai mikroskopis wajib diisi";
        }

        if (!values.jumplthan && values.jumplthan !== 0) {
          errors.jumplthan =
            "Jumlah pelatihan mikroskopis yang pernah diikuti wajib diisi";
        }

        if (values.jumplthan !== 0 && values.jumplthan !== "0") {
          if (!values.institusipmberiplth) {
            errors.institusipmberiplth =
              "Institusi pemberi pelatihan  wajib diisi";
          } else if (
            values.institusipmberiplth === "7" &&
            !values.institusipmberiplthsebutkan
          ) {
            errors.institusipmberiplthsebutkan =
              "Institusi pemberi pelatihan  wajib diisi";
          }
        }
      }

      if (values.jumplthan !== 0 && values.jumplthan !== "0") {
        if (values.thnplthanakhir && !values.nilaiplth) {
          errors.nilaiplth = "Nilai pelatihan wajib diisi";
        }

        if (values.nilaiplth === "Ya" && !values.hslplthsensi) {
          errors.hslplthsensi = "Hasil pelatihan wajib diisi";
        } else if (checkScoreInvalid(values.hslplthsensi)) {
          errors.hslplthsensi = "Nilai pelatihan harus antara 1 hingga 100";
        }

        if (values.nilaiplth === "Ya" && !values.hslplthspesi) {
          errors.hslplthspesi = "Hasil pelatihan wajib diisi";
        } else if (checkScoreInvalid(values.hslplthspesi)) {
          errors.hslplthspesi = "Nilai pelatihan harus antara 1 hingga 100";
        }

        if (values.nilaiplth === "Ya" && !values.hslplthakurasi) {
          errors.hslplthakurasi = "Hasil pelatihan wajib diisi";
        } else if (checkScoreInvalid(values.hslplthakurasi)) {
          errors.hslplthakurasi = "Nilai pelatihan harus antara 1 hingga 100";
        }
        if (values.nilaiplth === "Ya" && !values.hslplthhtungprst) {
          errors.hslplthhtungprst = "Hasil pelatihan wajib diisi";
        } else if (checkScoreInvalid(values.hslplthhtungprst)) {
          errors.hslplthhtungprst = "Nilai pelatihan harus antara 1 hingga 100";
        }
      }

      if (values.tglbimtekakhir && !values.bimtekpanel) {
        errors.bimtekpanel = "Uji Panel wajib diisi";
      }

      if (values.bimtekpanel === "Ya" && !values.hslbimteksensi) {
        errors.hslbimteksensi = "Hasil BIMTEK wajib diisi";
      } else if (checkScoreInvalid(values.hslbimteksensi)) {
        errors.hslbimteksensi = "Nilai BIMTEK harus antara 1 hingga 100";
      }

      if (values.bimtekpanel === "Ya" && !values.hslbimtekspesi) {
        errors.hslbimtekspesi = "Hasil BIMTEK wajib diisi";
      } else if (checkScoreInvalid(values.hslbimtekspesi)) {
        errors.hslbimtekspesi = "Nilai BIMTEK harus antara 1 hingga 100";
      }

      if (values.bimtekpanel === "Ya" && !values.hslbimtekakurasi) {
        errors.hslbimtekakurasi = "Hasil BIMTEK wajib diisi";
      } else if (checkScoreInvalid(values.hslbimtekakurasi)) {
        errors.hslbimtekakurasi = "Nilai BIMTEK harus antara 1 hingga 100";
      }

      if (values.bimtekpanel === "Ya" && !values.hslbimtekhtungprst) {
        errors.hslbimtekhtungprst = "Hasil BIMTEK wajib diisi";
      } else if (checkScoreInvalid(values.hslbimtekhtungprst)) {
        errors.hslbimtekhtungprst = "Nilai BIMTEK harus antara 1 hingga 100";
      }

      if (values.tglujiprofis && !values.hslujiprofis) {
        errors.hslujiprofis = "Hasil uji profisiensi wajib diisi";
      }

      if (checkScoreInvalid(values.hslujiprofis)) {
        errors.hslujiprofis = "Hasil uji profisiensi harus antara 1 hingga 100";
      }

      if (formik.values.hslujiprofis >= 20 && !values.hslprofissensi) {
        errors.hslprofissensi = "Hasil profisiensi wajib diisi";
      } else if (checkScoreInvalid(values.hslprofissensi)) {
        errors.hslprofissensi =
          "Hasil uji profisiensi harus antara 1 hingga 100";
      }
      if (formik.values.hslujiprofis >= 20 && !values.hslprofisspesi) {
        errors.hslprofisspesi = "Hasil profisiensi wajib diisi";
      } else if (checkScoreInvalid(values.hslprofisspesi)) {
        errors.hslprofisspesi =
          "Hasil uji profisiensi harus antara 1 hingga 100";
      }

      if (formik.values.hslujiprofis >= 20 && !values.hslprofisakurasi) {
        errors.hslprofisakurasi = "Hasil profisiensi wajib diisi";
      } else if (checkScoreInvalid(values.hslprofisakurasi)) {
        errors.hslprofisakurasi =
          "Hasil uji profisiensi harus antara 1 hingga 100";
      }
      if (formik.values.hslujiprofis >= 20 && !values.hslprofisparasit) {
        errors.hslprofisparasit = "Hasil profisiensi wajib diisi";
      } else if (checkScoreInvalid(values.hslprofisparasit)) {
        errors.hslprofisparasit =
          "Hasil uji profisiensi harus antara 1 hingga 100";
      }

      if (values.tglujiprofis && !values.institusiujiprofis) {
        errors.institusiujiprofis = "Institusi uji profisiensi wajib diisi";
      } else if (
        values.tglujiprofis &&
        values.institusiujiprofis === "5" &&
        !values.institusiujiprofissebutkan
      ) {
        errors.institusiujiprofissebutkan =
          "Institusi uji profisiensi Lainnya wajib diisi";
      }

      if (values.tglujikompakhir) {
        if (!values.jenisujikompakhir) {
          errors.jenisujikompakhir = "Jenis uji kompetensi wajib diisi";
        }
        if (!values.hslujikompakhir) {
          errors.hslujikompakhir = "Hasil uji kompetensi wajib diisi";
        }
      }

      return errors;
    },
    onSubmit: async (values) => {
      const payload = {
        kd_prop: currentUser?.province_id
          ? currentUser.province_id.split("|")[0]
          : "",
        kd_kab: currentUser?.district_id
          ? currentUser.district_id.split("|")[0]
          : "",
        kd_faskes: currentUser?.fasyankes_id
          ? currentUser.fasyankes_id.split("|")[0]
          : "",
        tgl_simpan: moment().format("YYYY-MM-DD"),
        sediamikroskopis: values.sediamikroskopis,
        namapetugas: values.namapetugas,
        stspegawai: values.stspegawai,
        nip: values.nip,
        tlahir: values.tlahir
          ? moment(values.tlahir).format("YYYY-MM-DD")
          : null,
        tglmulaikerja: values.tglmulaikerja
          ? moment(values.tglmulaikerja).format("YYYY-MM-DD")
          : null,
        pddkan: values.pddkan,
        jumplthan: values.jumplthan,
        institusipmberiplth: values.institusipmberiplth,
        institusipmberiplthsebutkan: values.institusipmberiplthsebutkan,
        thnplthanakhir: values.thnplthanakhir
          ? moment(values.thnplthanakhir).format("YYYY-MM-DD")
          : null,
        nilaiplth: values.nilaiplth,
        hslplthsensi: values.hslplthsensi,
        hslplthspesi: values.hslplthspesi,
        hslplthakurasi: values.hslplthakurasi,
        hslplthhtungprst: values.hslplthhtungprst,
        tglbimtekakhir: values.tglbimtekakhir
          ? moment(values.tglbimtekakhir).format("YYYY-MM-DD")
          : null,
        bimtekpanel: values.bimtekpanel,
        hslbimteksensi: values.hslbimteksensi,
        hslbimtekspesi: values.hslbimtekspesi,
        hslbimtekakurasi: values.hslbimtekakurasi,
        hslbimtekhtungprst: values.hslbimtekhtungprst,
        tglujiprofis: values.tglujiprofis
          ? moment(values.tglujiprofis).format("YYYY-MM-DD")
          : null,
        institusiujiprofis: values.institusiujiprofis,
        institusiujiprofissebutkan: values.institusiujiprofissebutkan,
        hslujiprofis: values.hslujiprofis,
        hslprofissensi: values.hslprofissensi,
        hslprofisspesi: values.hslprofisspesi,
        hslprofisakurasi: values.hslprofisakurasi,
        hslprofisparasit: values.hslprofisparasit,
        tglujikompakhir: values.tglujikompakhir
          ? moment(values.tglujikompakhir).format("YYYY-MM-DD")
          : null,
        jenisujikompakhir: values.jenisujikompakhir,
        hslujikompakhir: values.hslujikompakhir,
      };

      switch (pageMode) {
        case PageMode.add:
          await MikroscopisService.add(payload)
            .then((res) => {
              handlePageModeChange(PageMode.view);
              toast.success("Data Mikroskopis berhasil ditambahkan", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                theme: "colored",
                draggable: true,
              });
            })
            .catch((err) => {
              errorToastNotif(err);
            });
          break;
        case PageMode.edit:
          await MikroscopisService.update(payload, selectedItem?.kd_id)
            .then((res) => {
              handlePageModeChange(PageMode.view);
              toast.success("Data Mikroskopis berhasil diupdate", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                theme: "colored",
                draggable: true,
              });
            })
            .catch((err) => {
              errorToastNotif(err);
            });
          break;
      }
    },
  });

  const getUrbanvillagesByCurrentUser = async () => {
    try {
      const response = await WilayahService.getAll(Source.URBANVILLAGE, {
        searchBy: "subdistrict_id",
        searchValue: currentUser?.subdistrict_id?.split("|")[0],
        page: 1,
        limit: 9999,
      });
      setUrbanvillages(response.urbanvillage);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUrbanvillagesByCurrentUser();
  }, []);

  useEffect(() => {
    if (pageMode === PageMode.edit) {
      formik.setValues({
        province_id: selectedItem.kd_prop,
        district_id: selectedItem.kd_kab,
        fasyankes_id: selectedItem.kd_faskes,
        sediamikroskopis: selectedItem.sediamikroskopis,
        namapetugas: selectedItem.namapetugas,
        stspegawai: selectedItem.stspegawai,
        nip: selectedItem.nip,
        tlahir: selectedItem.tlahir
          ? moment(selectedItem.tlahir).format("YYYY-MM-DD")
          : null,
        tglmulaikerja: selectedItem.tglmulaikerja
          ? moment(selectedItem.tglmulaikerja).format("YYYY-MM-DD")
          : null,
        pddkan: selectedItem.pddkan,
        jumplthan: selectedItem.jumplthan,
        institusipmberiplth: selectedItem.institusipmberiplth,
        institusipmberiplthsebutkan: selectedItem.institusipmberiplthsebutkan,
        thnplthanakhir: selectedItem.thnplthanakhir
          ? moment(selectedItem.thnplthanakhir).format("YYYY-MM-DD")
          : null,
        nilaiplth: selectedItem.nilaiplth,
        hslplthsensi: selectedItem.hslplthsensi,
        hslplthspesi: selectedItem.hslplthspesi,
        hslplthakurasi: selectedItem.hslplthakurasi,
        hslplthhtungprst: selectedItem.hslplthhtungprst,
        tglbimtekakhir: selectedItem.tglbimtekakhir
          ? moment(selectedItem.tglbimtekakhir).format("YYYY-MM-DD")
          : null,
        hslbimteksensi: selectedItem.hslbimteksensi,
        hslbimtekspesi: selectedItem.hslbimtekspesi,
        hslbimtekakurasi: selectedItem.hslbimtekakurasi,
        hslbimtekhtungprst: selectedItem.hslbimtekhtungprst,
        bimtekpanel: selectedItem.bimtekpanel,
        tglujiprofis: selectedItem.tglujiprofis
          ? moment(selectedItem.tglujiprofis).format("YYYY-MM-DD")
          : null,
        institusiujiprofis: selectedItem.institusiujiprofis,
        institusiujiprofissebutkan: selectedItem.institusiujiprofissebutkan,
        hslujiprofis: selectedItem.hslujiprofis,
        hslprofissensi: selectedItem.hslprofissensi,
        hslprofisspesi: selectedItem.hslprofisspesi,
        hslprofisakurasi: selectedItem.hslprofisakurasi,
        hslprofisparasit: selectedItem.hslprofisparasit,
        tglujikompakhir: selectedItem.tglujikompakhir
          ? moment(selectedItem.tglujikompakhir).format("YYYY-MM-DD")
          : null,
        jenisujikompakhir: selectedItem.jenisujikompakhir,
        hslujikompakhir: selectedItem.hslujikompakhir,
      });
    }
  }, [selectedItem]);

  return (
    <>
      <h1 className="page-title">
        {pageMode === PageMode.add
          ? "Tambah Mikroskopis - Fasyankes"
          : "Edit Mikroskopis - Fasyankes"}
      </h1>

      <div className="form-grouping">
        <p
          className="warning"
          style={{ marginTop: "24px", marginBottom: "24px" }}
        >
          NOTE<span>*(WAJIB DIISI)</span>
        </p>

        <div className="row">
          <div className="col-sm-4 mb-3">
            <InputSelect
              isClearable={false}
              placeholder={"Pilih Provinsi"}
              data={levelDataOptions.provinces}
              onChange={(e) => {
                setSelectedProvince(e.value);
                setSelectedFasyankes("");
                setSelectedDistrict("");
              }}
              value={
                levelDataOptions.provinces?.find(
                  (item) => item.value === selectedProvince
                ) || ""
              }
              isDisabled={true}
            />
          </div>
          <div className="col-sm-4 mb-3">
            <InputSelect
              isClearable={false}
              placeholder={"Pilih Kab/Kota"}
              data={levelDataOptions.districts}
              onChange={(e) => {
                setSelectedDistrict(e.value);
                setSelectedFasyankes("");
              }}
              value={
                levelDataOptions.districts?.find(
                  (item) => item.value === selectedDistrict
                ) || ""
              }
              isDisabled={true}
            />
          </div>
          <div className="col-sm-4 mb-3">
            <InputSelect
              isClearable={false}
              isMultipleSelect={false}
              placeholder={"Pilih Fasyankes"}
              data={
                currentUser.level === UserLevel.Fasyankes
                  ? levelDataOptions.fasyankes?.filter(
                      (item) => item.value === currentUser?.fasyankes_id
                    )
                  : levelDataOptions.fasyankes
              }
              onChange={(e) => {
                let value = e.map(function (item) {
                  return item.value;
                });
                let resultValue = value.join(",");
                setSelectedFasyankes(resultValue);
                setLevelIdValue(resultValue);
              }}
              value={levelDataOptions.fasyankes?.filter((item) =>
                selectedFasyankes?.includes(item.value)
              )}
              isDisabled={true}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-4">
            <InputSelect
              label={"Tersedia mikroskopis ?"}
              name={"sediamikroskopis"}
              placeholder={"Pilih Tersedia mikroskopis ?"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("sediamikroskopis", selectedValue);

                if (selectedValue !== "Ya") {
                  for (let index = 0; index < disableField.length; index++) {
                    formik.setFieldValue(disableField[index], "");
                  }
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.sediamikroskopis
              )}
              error={
                formik.errors.sediamikroskopis &&
                formik.touched.sediamikroskopis
              }
              errorMessage={formik.errors.sediamikroskopis}
              isRequired={true}
            />
          </div>
          <div className="col-sm-4">
            <InputField
              label={"Nama mikroskopis"}
              name={"namapetugas"}
              placeholder={"Masukkan Nama mikroskopis"}
              type={"text"}
              {...formik.getFieldProps("namapetugas")}
              error={formik.errors.namapetugas && formik.touched.namapetugas}
              errorMessage={formik.errors.namapetugas}
              disabled={formik.values.sediamikroskopis !== "Ya"}
            />
          </div>
          <div className="col-sm-4">
            <InputSelect
              label={"Status kepegawaian"}
              name={"stspegawai"}
              placeholder={"Pilih Status kepegawaian"}
              data={EmployeeStatusOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("stspegawai", selectedValue);
              }}
              onBlur={formik.handleBlur}
              value={EmployeeStatusOptions.find(
                (option) => option.value === formik.values.stspegawai
              )}
              error={formik.errors.stspegawai && formik.touched.stspegawai}
              errorMessage={formik.errors.stspegawai}
              isRequired={formik.values.sediamikroskopis === "Ya"}
              disabled={formik.values.sediamikroskopis !== "Ya"}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputField
              label={"NIP/KTP"}
              name={"nip"}
              placeholder={"Masukkan NIP/KTP"}
              type={"number"}
              maxLengthVal={16}
              value={formik.values.nip}
              {...formik.getFieldProps("nip")}
              error={formik.errors.nip && formik.touched.nip}
              errorMessage={formik.errors.nip}
              isRequired={formik.values.sediamikroskopis === "Ya"}
              disabled={formik.values.sediamikroskopis !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              dateFormat={"YYYY-MM-DD"}
              label={"Tanggal lahir"}
              name={"tlahir"}
              placeholder={"Masukkan Tanggal lahir"}
              onChange={(e) => {
                const selectedDate = e ? moment(e).format("YYYY-MM-DD") : "";
                formik.setFieldValue("tlahir", selectedDate);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.tlahir}
              error={formik.errors.tlahir && formik.touched.tlahir}
              errorMessage={formik.errors.tlahir}
              isClearable={true}
              isRequired={formik.values.sediamikroskopis === "Ya"}
              isDisabled={formik.values.sediamikroskopis !== "Ya"}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={"Pendidikan terakhir"}
              name={"pddkan"}
              placeholder={"Pilih Pendidikan terakhir"}
              data={LastEducationOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("pddkan", selectedValue);
              }}
              onBlur={formik.handleBlur}
              value={LastEducationOptions.find(
                (option) => option.value === formik.values.pddkan
              )}
              error={formik.errors.pddkan && formik.touched.pddkan}
              errorMessage={formik.errors.pddkan}
              isRequired={formik.values.sediamikroskopis === "Ya"}
              disabled={formik.values.sediamikroskopis !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              dateFormat={"YYYY-MM-DD"}
              label={"Tanggal mulai bekerja sebagai mikroskopis"}
              name={"tglmulaikerja"}
              placeholder={"Masukkan Tanggal mulai bekerja sebagai mikroskopis"}
              onChange={(e) => {
                const selectedDate = e ? moment(e).format("YYYY-MM-DD") : "";
                formik.setFieldValue("tglmulaikerja", selectedDate);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.tglmulaikerja}
              error={
                formik.errors.tglmulaikerja && formik.touched.tglmulaikerja
              }
              errorMessage={formik.errors.tglmulaikerja}
              isClearable={true}
              isRequired={formik.values.sediamikroskopis === "Ya"}
              isDisabled={formik.values.sediamikroskopis !== "Ya"}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={"Jumlah pelatihan mikroskopis yang pernah diikuti"}
              name={"jumplthan"}
              placeholder={
                "Pilih Jumlah pelatihan mikroskopis yang pernah diikuti"
              }
              data={NumberOfMicroscopicTrainingOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("jumplthan", selectedValue);
                if (selectedValue === 0 || selectedValue === "0") {
                  trainingRangeFields.forEach((field) =>
                    formik.setFieldValue(field, "")
                  );
                }
              }}
              onBlur={formik.handleBlur}
              value={NumberOfMicroscopicTrainingOptions.find(
                (option) => option.value === formik.values.jumplthan
              )}
              error={formik.errors.jumplthan && formik.touched.jumplthan}
              errorMessage={formik.errors.jumplthan}
              isRequired={formik.values.sediamikroskopis === "Ya"}
              disabled={formik.values.sediamikroskopis !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputSelect
              label={"Institusi pemberi pelatihan"}
              name={"institusipmberiplth"}
              placeholder={"Pilih Institusi pemberi pelatihan"}
              data={TrainingProvidingInstitutionsOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("institusipmberiplth", selectedValue);
                if (selectedValue !== "7") {
                  formik.setFieldValue("institusipmberiplthsebutkan", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={TrainingProvidingInstitutionsOptions.find(
                (option) => option.value === formik.values.institusipmberiplth
              )}
              error={
                formik.errors.institusipmberiplth &&
                formik.touched.institusipmberiplth
              }
              errorMessage={formik.errors.institusipmberiplth}
              isRequired={
                formik.values.sediamikroskopis === "Ya" &&
                formik.values.jumplthan !== 0 &&
                formik.values.jumplthan !== "0"
              }
              disabled={isTrainingDisabled(formik.values)}
            />
          </div>
        </div>
        {formik.values.institusipmberiplth === "7" && (
          <InputField
            label={"Sebutkan institusi"}
            name={"institusipmberiplthsebutkan"}
            placeholder={"Masukkan Institusi"}
            type={"text"}
            {...formik.getFieldProps("institusipmberiplthsebutkan")}
            error={
              formik.errors.institusipmberiplthsebutkan &&
              formik.touched.institusipmberiplthsebutkan
            }
            errorMessage={formik.errors.institusipmberiplthsebutkan}
            isRequired={formik.values.institusipmberiplth === "7"}
            value={formik.values.institusipmberiplthsebutkan}
            disabled={isTrainingDisabled(formik.values)}
          />
        )}
        <hr />
        <div className="row">
          <div className="col-sm-6">
            <InputDate
              dateFormat={"YYYY-MM-DD"}
              label={"Tanggal pelatihan terakhir"}
              name={"thnplthanakhir"}
              placeholder={"Masukkan Tanggal pelatihan terakhir"}
              onChange={(e) => {
                const selectedDate = e ? moment(e).format("YYYY-MM-DD") : "";
                formik.setFieldValue("thnplthanakhir", selectedDate);

                if (selectedDate === "") {
                  formik.setFieldValue("nilaiplth", "");
                  formik.setFieldValue("hslplthsensi", "");
                  formik.setFieldValue("hslplthspesi", "");
                  formik.setFieldValue("hslplthakurasi", "");
                  formik.setFieldValue("hslplthhtungprst", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={formik.values.thnplthanakhir}
              error={
                formik.errors.thnplthanakhir && formik.touched.thnplthanakhir
              }
              isClearable={true}
              errorMessage={formik.errors.thnplthanakhir}
              isDisabled={isTrainingDisabled(formik.values)}
            />
          </div>
          <div className="col-sm-6">
            <InputSelect
              label={"Nilai pelatihan ?"}
              name={"nilaiplth"}
              placeholder={"Pilih Nilai pelatihan"}
              data={YesAndNoTrainingValueOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("nilaiplth", selectedValue);

                if (selectedValue !== "Ya") {
                  formik.setFieldValue("hslplthsensi", "");
                  formik.setFieldValue("hslplthspesi", "");
                  formik.setFieldValue("hslplthakurasi", "");
                  formik.setFieldValue("hslplthhtungprst", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoTrainingValueOptions.find(
                (option) => option.value === formik.values.nilaiplth
              )}
              error={formik.errors.nilaiplth && formik.touched.nilaiplth}
              errorMessage={formik.errors.nilaiplth}
              disabled={
                isTrainingDisabled(formik.values) ||
                !formik.values.thnplthanakhir
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputField
              label={"Hasil pelatihan terakhir (SENSITIFITAS; 1-100)"}
              name={"hslplthsensi"}
              placeholder={"Masukkan Hasil"}
              type={"number"}
              maxLengthVal={3}
              {...formik.getFieldProps("hslplthsensi")}
              error={formik.errors.hslplthsensi && formik.touched.hslplthsensi}
              value={formik.values.hslplthsensi}
              errorMessage={formik.errors.hslplthsensi}
              disabled={
                isTrainingDisabled(formik.values) ||
                formik.values.nilaiplth !== "Ya"
              }
            />
          </div>
          <div className="col-sm-6">
            <InputField
              label={"Hasil pelatihan terakhir (SPESIFITAS; 1-100)"}
              name={"hslplthspesi"}
              placeholder={"Masukkan Hasil"}
              type={"number"}
              maxLengthVal={3}
              value={formik.values.hslplthspesi}
              {...formik.getFieldProps("hslplthspesi")}
              error={formik.errors.hslplthspesi && formik.touched.hslplthspesi}
              errorMessage={formik.errors.hslplthspesi}
              disabled={
                isTrainingDisabled(formik.values) ||
                formik.values.nilaiplth !== "Ya"
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputField
              label={"Hasil pelatihan terakhir (AKURASI SPESIES; 1-100)"}
              name={"hslplthakurasi"}
              placeholder={"Masukkan Hasil"}
              type={"number"}
              maxLengthVal={3}
              value={formik.values.hslplthakurasi}
              {...formik.getFieldProps("hslplthakurasi")}
              error={
                formik.errors.hslplthakurasi && formik.touched.hslplthakurasi
              }
              errorMessage={formik.errors.hslplthakurasi}
              disabled={
                isTrainingDisabled(formik.values) ||
                formik.values.nilaiplth !== "Ya"
              }
            />
          </div>
          <div className="col-sm-6">
            <InputField
              label={"Hasil pelatihan terakhir (HITUNG PARASIT; 1-100)"}
              name={"hslplthhtungprst"}
              placeholder={"Masukkan Hasil"}
              type={"number"}
              maxLengthVal={3}
              value={formik.values.hslplthhtungprst}
              {...formik.getFieldProps("hslplthhtungprst")}
              error={
                formik.errors.hslplthhtungprst &&
                formik.touched.hslplthhtungprst
              }
              errorMessage={formik.errors.hslplthhtungprst}
              disabled={
                isTrainingDisabled(formik.values) ||
                formik.values.nilaiplth !== "Ya"
              }
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-sm-6">
            <InputDate
              dateFormat={"YYYY-MM-DD"}
              label={"Tanggal bimtek terakhir"}
              name={"tglbimtekakhir"}
              placeholder={"Masukkan Tanggal bimtek terakhir"}
              onChange={(e) => {
                const selectedDate = e ? moment(e).format("YYYY-MM-DD") : "";
                formik.setFieldValue("tglbimtekakhir", selectedDate);

                if (selectedDate === "") {
                  formik.setFieldValue("bimtekpanel", "");
                  formik.setFieldValue("hslbimteksensi", "");
                  formik.setFieldValue("hslbimtekspesi", "");
                  formik.setFieldValue("hslbimtekakurasi", "");
                  formik.setFieldValue("hslbimtekhtungprst", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={formik.values.tglbimtekakhir}
              error={
                formik.errors.tglbimtekakhir && formik.touched.tglbimtekakhir
              }
              isClearable={true}
              errorMessage={formik.errors.tglbimtekakhir}
              isDisabled={isGeneralDisabled(formik.values)}
            />
          </div>
          <div className="col-sm-6">
            <InputSelect
              label={"Uji panel ?"}
              name={"bimtekpanel"}
              placeholder={"Pilih Uji panel"}
              data={YesAndNoTestPanelOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("bimtekpanel", selectedValue);

                if (selectedValue !== "Ya") {
                  formik.setFieldValue("hslbimteksensi", "");
                  formik.setFieldValue("hslbimtekspesi", "");
                  formik.setFieldValue("hslbimtekakurasi", "");
                  formik.setFieldValue("hslbimtekhtungprst", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoTestPanelOptions.find(
                (option) => option.value === formik.values.bimtekpanel
              )}
              error={formik.errors.bimtekpanel && formik.touched.bimtekpanel}
              errorMessage={formik.errors.bimtekpanel}
              disabled={
                isGeneralDisabled(formik.values) ||
                !formik.values.tglbimtekakhir
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputField
              label={
                "Hasil tes panel dari bimtek terakhir (SENSITIFITAS; 1-100)"
              }
              name={"hslbimteksensi"}
              placeholder={"Masukkan Hasil"}
              type={"number"}
              maxLengthVal={3}
              value={formik.values.hslbimteksensi}
              {...formik.getFieldProps("hslbimteksensi")}
              error={
                formik.errors.hslbimteksensi && formik.touched.hslbimteksensi
              }
              errorMessage={formik.errors.hslbimteksensi}
              disabled={
                isGeneralDisabled(formik.values) ||
                formik.values.bimtekpanel !== "Ya"
              }
            />
          </div>
          <div className="col-sm-6">
            <InputField
              label={"Hasil tes panel dari bimtek terakhir (SPESIFITAS; 1-100)"}
              name={"hslbimtekspesi"}
              placeholder={"Masukkan Hasil"}
              type={"number"}
              maxLengthVal={3}
              value={formik.values.hslbimtekspesi}
              {...formik.getFieldProps("hslbimtekspesi")}
              error={
                formik.errors.hslbimtekspesi && formik.touched.hslbimtekspesi
              }
              errorMessage={formik.errors.hslbimtekspesi}
              disabled={
                isGeneralDisabled(formik.values) ||
                formik.values.bimtekpanel !== "Ya"
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputField
              label={
                "Hasil tes panel dari bimtek terakhir (AKURASI SPESIES; 1-100)"
              }
              name={"hslbimtekakurasi"}
              placeholder={"Masukkan Hasil"}
              type={"number"}
              maxLengthVal={3}
              value={formik.values.hslbimtekakurasi}
              {...formik.getFieldProps("hslbimtekakurasi")}
              error={
                formik.errors.hslbimtekakurasi &&
                formik.touched.hslbimtekakurasi
              }
              errorMessage={formik.errors.hslbimtekakurasi}
              disabled={
                isGeneralDisabled(formik.values) ||
                formik.values.bimtekpanel !== "Ya"
              }
            />
          </div>
          <div className="col-sm-6">
            <InputField
              label={
                "Hasil tes panel dari bimtek terakhir (HITUNG PARASIT; 1-100)"
              }
              name={"hslbimtekhtungprst"}
              placeholder={"Masukkan Hasil"}
              type={"number"}
              maxLengthVal={3}
              value={formik.values.hslbimtekhtungprst}
              {...formik.getFieldProps("hslbimtekhtungprst")}
              error={
                formik.errors.hslbimtekhtungprst &&
                formik.touched.hslbimtekhtungprst
              }
              errorMessage={formik.errors.hslbimtekhtungprst}
              disabled={
                isGeneralDisabled(formik.values) ||
                formik.values.bimtekpanel !== "Ya"
              }
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-sm-6">
            <InputDate
              dateFormat={"YYYY-MM-DD"}
              label={"Tanggal uji profisiensi"}
              name={"tglujiprofis"}
              placeholder={"Masukkan Tanggal uji profisiensi"}
              onChange={(e) => {
                const selectedDate = e ? moment(e).format("YYYY-MM-DD") : "";
                formik.setFieldValue("tglujiprofis", selectedDate);
                if (selectedDate === "") {
                  formik.setFieldValue("hslujiprofis", "");
                  formik.setFieldValue("hslprofissensi", "");
                  formik.setFieldValue("hslprofisspesi", "");
                  formik.setFieldValue("hslprofisakurasi", "");
                  formik.setFieldValue("hslprofisparasit", "");
                  formik.setFieldValue("institusiujiprofis", "");
                  formik.setFieldValue("institusiujiprofissebutkan", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={formik.values.tglujiprofis}
              error={formik.errors.tglujiprofis && formik.touched.tglujiprofis}
              errorMessage={formik.errors.tglujiprofis}
              isClearable={true}
              isDisabled={isGeneralDisabled(formik.values)}
            />
          </div>
          <div className="col-sm-6">
            <InputField
              label={"Hasil uji profisiensi(1-100)"}
              name={"hslujiprofis"}
              placeholder={"Masukkan Hasil"}
              type={"number"}
              maxLengthVal={3}
              onBlur={formik.handleBlur}
              value={formik.values.hslujiprofis}
              onChange={(e) => {
                const value = parseInt(e.target.value || "0", 0);
                formik.setFieldValue("hslujiprofis", value);
                if (value < 20) {
                  formik.setFieldValue("hslprofissensi", "");
                  formik.setFieldValue("hslprofisspesi", "");
                  formik.setFieldValue("hslprofisakurasi", "");
                  formik.setFieldValue("hslprofisparasit", "");
                }
              }}
              error={formik.errors.hslujiprofis && formik.touched.hslujiprofis}
              errorMessage={formik.errors.hslujiprofis}
              disabled={
                isGeneralDisabled(formik.values) ||
                !formik.values.tglujiprofis
              }
            />
          </div>
        </div>
        {formik.values.hslujiprofis >= 20 &&
          formik.values.sediamikroskopis === "Ya" &&
          (() => {
            const commonProps = {
              isRequired: formik.values.hslujiprofis >= 20,
              disabled:
                isGeneralDisabled(formik.values) ||
                (formik.values.sediamikroskopis === "Ya" &&
                  formik.values.hslujiprofis < 20),
            };

            return (
              <>
                <div className="row">
                  <div className="col-sm-6">
                    <InputField
                      label="Hasil uji profisiensi (SENSITIFITAS; 1-100)"
                      name="hslprofissensi"
                      placeholder="Masukkan Hasil"
                      type="number"
                      maxLengthVal={3}
                      {...formik.getFieldProps("hslprofissensi")}
                      error={
                        formik.errors.hslprofissensi &&
                        formik.touched.hslprofissensi
                      }
                      value={formik.values.hslprofissensi}
                      errorMessage={formik.errors.hslprofissensi}
                      {...commonProps}
                    />
                  </div>
                  <div className="col-sm-6">
                    <InputField
                      label="Hasil uji profisiensi (SPESIFITAS; 1-100)"
                      name="hslprofisspesi"
                      placeholder="Masukkan Hasil"
                      type="number"
                      maxLengthVal={3}
                      {...formik.getFieldProps("hslprofisspesi")}
                      error={
                        formik.errors.hslprofisspesi &&
                        formik.touched.hslprofisspesi
                      }
                      value={formik.values.hslprofisspesi}
                      errorMessage={formik.errors.hslprofisspesi}
                      {...commonProps}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    <InputField
                      label="Hasil uji profisiensi (AKURASI SPESIES; 1-100)"
                      name="hslprofisakurasi"
                      placeholder="Masukkan Hasil"
                      type="number"
                      maxLengthVal={3}
                      {...formik.getFieldProps("hslprofisakurasi")}
                      error={
                        formik.errors.hslprofisakurasi &&
                        formik.touched.hslprofisakurasi
                      }
                      value={formik.values.hslprofisakurasi}
                      errorMessage={formik.errors.hslprofisakurasi}
                      {...commonProps}
                    />
                  </div>
                  <div className="col-sm-6">
                    <InputField
                      label="Hasil uji profisiensi (HITUNG PARASIT; 1-100)"
                      name="hslprofisparasit"
                      placeholder="Masukkan Hasil"
                      type="number"
                      maxLengthVal={3}
                      {...formik.getFieldProps("hslprofisparasit")}
                      error={
                        formik.errors.hslprofisparasit &&
                        formik.touched.hslprofisparasit
                      }
                      value={formik.values.hslprofisparasit}
                      errorMessage={formik.errors.hslprofisparasit}
                      {...commonProps}
                    />
                  </div>
                </div>
              </>
            );
          })()}
        <div className="row">
          <div
            className={
              formik.values.institusiujiprofis === "5"
                ? "col-sm-6"
                : "col-sm-12"
            }
          >
            <InputSelect
              label={"Institusi uji profisiensi"}
              name={"institusiujiprofis"}
              placeholder={"Pilih Institusi uji profisiensi"}
              data={ProficiencyTestingInstitutionOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("institusiujiprofis", selectedValue);
                if (selectedValue !== "5") {
                  formik.setFieldValue("institusiujiprofissebutkan", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={ProficiencyTestingInstitutionOptions.find(
                (option) => option.value === formik.values.institusiujiprofis
              )}
              error={
                formik.errors.institusiujiprofis &&
                formik.touched.institusiujiprofis
              }
              errorMessage={formik.errors.institusiujiprofis}
              disabled={
                isGeneralDisabled(formik.values) ||
                !formik.values.tglujiprofis
              }
            />
          </div>
          {formik.values.institusiujiprofis === "5" && (
            <div className="col-sm-6">
              <InputField
                label={"Sebutkan institusi uji profisiensi"}
                name={"institusiujiprofissebutkan"}
                placeholder={"Masukkan Institusi"}
                type={"text"}
                value={formik.values.institusiujiprofissebutkan}
                {...formik.getFieldProps("institusiujiprofissebutkan")}
                error={
                  formik.errors.institusiujiprofissebutkan &&
                  formik.touched.institusiujiprofissebutkan
                }
                errorMessage={formik.errors.institusiujiprofissebutkan}
                disabled={isGeneralDisabled(formik.values)}
              />
            </div>
          )}
        </div>
        <hr />
        <div className="row">
          <div className="col-sm-4">
            <InputDate
              dateFormat={"YYYY-MM-DD"}
              label={"Tanggal uji kompetensi terakhir"}
              name={"tglujikompakhir"}
              placeholder={"Masukkan Tanggal uji kompetensi terakhir"}
              onChange={(e) => {
                const selectedDate = e ? moment(e).format("YYYY-MM-DD") : "";
                formik.setFieldValue("tglujikompakhir", selectedDate);
                if (selectedDate === "") {
                  formik.setFieldValue("jenisujikompakhir", "");
                  formik.setFieldValue("hslujikompakhir", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={formik.values.tglujikompakhir}
              error={
                formik.errors.tglujikompakhir && formik.touched.tglujikompakhir
              }
              errorMessage={formik.errors.tglujikompakhir}
              isClearable={true}
              isDisabled={isGeneralDisabled(formik.values)}
            />
          </div>
          <div className="col-sm-4">
            <InputSelect
              label={"Jenis uji kompetensi"}
              name={"jenisujikompakhir"}
              placeholder={"Pilih Jenis uji kompetensi"}
              data={TypeofCompetencyTestOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("jenisujikompakhir", selectedValue);
              }}
              onBlur={formik.handleBlur}
              value={TypeofCompetencyTestOptions.find(
                (option) => option.value === formik.values.jenisujikompakhir
              )}
              error={
                formik.errors.jenisujikompakhir &&
                formik.touched.jenisujikompakhir
              }
              errorMessage={formik.errors.jenisujikompakhir}
              disabled={
                isGeneralDisabled(formik.values) ||
                !formik.values.tglujikompakhir
              }
            />
          </div>
          <div className="col-sm-4">
            <InputSelect
              label={"Hasil uji kompetensi"}
              name={"hslujikompakhir"}
              placeholder={"Pilih Hasil uji kompetensi"}
              data={CompetencyTestResultsFasyankesOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("hslujikompakhir", selectedValue);
              }}
              onBlur={formik.handleBlur}
              value={CompetencyTestResultsFasyankesOptions.find(
                (option) => option.value === formik.values.hslujikompakhir
              )}
              error={
                formik.errors.hslujikompakhir && formik.touched.hslujikompakhir
              }
              errorMessage={formik.errors.hslujikompakhir}
              disabled={
                isGeneralDisabled(formik.values) ||
                !formik.values.tglujikompakhir
              }
            />
          </div>
        </div>

        {/* Action button */}
        <div className="button_action">
          <Button
            variant={"tertiary"}
            size={"normal"}
            onClick={() => handlePageModeChange(PageMode.view)}
          >
            Batalkan
          </Button>
          <Button
            type={"submit"}
            variant={"primary"}
            size={"normal"}
            onClick={formik.handleSubmit}
            isDisabled={formik.isSubmitting || !formik.values.sediamikroskopis}
          >
            {pageMode === PageMode.edit ? "Ubah Data" : "Simpan Data"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default FormComponent;
